/**
 * MRR bridge: MRR_t = prev + new + expansion - contraction - churn (+ shock).
 */

function roundMoney(n) {
  return Math.round(n * 100) / 100;
}

/**
 * @param {number} prevMrr
 * @param {{ newMrr?: number, expansion?: number, contraction?: number, churnMrr?: number, shock?: number }} deltas
 */
export function rollForwardMrr(prevMrr, deltas = {}) {
  const {
    newMrr = 0,
    expansion = 0,
    contraction = 0,
    churnMrr = 0,
    shock = 0,
  } = deltas;
  return roundMoney(prevMrr + newMrr + expansion - contraction - churnMrr + shock);
}

/**
 * Expansion/contraction as % of retained MRR (after logo churn, before expansion).
 * @param {number} retainedMrr — MRR on logos that survived churn
 * @param {number} expansionPct — monthly % (e.g. 1 = 1%)
 * @param {number} contractionPct
 */
export function computeExpansionContraction(retainedMrr, expansionPct = 0, contractionPct = 0) {
  const base = Math.max(0, Number(retainedMrr) || 0);
  const expansion = base * (Math.max(0, Number(expansionPct) || 0) / 100);
  const contraction = base * (Math.max(0, Number(contractionPct) || 0) / 100);
  return {
    expansion: roundMoney(expansion),
    contraction: roundMoney(contraction),
  };
}

/**
 * Build MRR bridge row for a month.
 * @param {object} params
 */
export function buildMrrBridgeRow(params) {
  const {
    monthIndex,
    prevMrr,
    newMrr,
    expansion,
    contraction,
    churnMrr,
    shock = 0,
    endMrr,
    prevLogos,
    newLogos,
    churnedLogos,
    endLogos,
  } = params;

  return {
    label: monthIndex === 0 ? 'Now' : `M${monthIndex}`,
    monthIndex,
    prevMrr: roundMoney(prevMrr),
    newMrr: roundMoney(newMrr),
    expansion: roundMoney(expansion),
    contraction: roundMoney(contraction),
    churnMrr: roundMoney(churnMrr),
    shock: roundMoney(shock),
    endMrr: roundMoney(endMrr),
    netMrrChange: roundMoney(endMrr - prevMrr),
    prevLogos: roundPct(prevLogos),
    newLogos: roundPct(newLogos),
    churnedLogos: roundPct(churnedLogos),
    endLogos: roundPct(endLogos),
  };
}

function roundPct(n) {
  return Math.round(n * 10) / 10;
}
